import '../stylesheets/countryInfoPage.css';

const CountryInfoPage = () => {
  return (
    <main>
      <p>Under construction!</p>
    </main>
  );
};

export default CountryInfoPage;
